// frontend/src/pages/Reports.js
import React, { useState } from 'react';
import SalesReport   from './reports/SalesReport';
import StaleListings from './reports/StaleListings';
import DuplicateSKUs from './reports/DuplicateSKUs';

const TABS = [
  { id: 'sales',      label: '💰 Sales'           },
  { id: 'stale',      label: '⏳ Stale Listings'   },
  { id: 'duplicates', label: '🔀 Duplicate SKUs'   },
];

export default function Reports() {
  const [tab, setTab] = useState('sales');
  return (
    <div>
      <div className="page-header" style={{ marginBottom:20 }}>
        <div className="page-title">📊 Reports</div>
      </div>
      <div className="filter-tabs" style={{ marginBottom:24 }}>
        {TABS.map(t => (
          <button key={t.id} className={`filter-tab ${tab === t.id ? 'active' : ''}`} onClick={() => setTab(t.id)}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'sales'      && <SalesReport />}
      {tab === 'stale'      && <StaleListings />}
      {tab === 'duplicates' && <DuplicateSKUs />}
    </div>
  );
}
